import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as ExpandedDomainsDataAction from '../actions/domain-expanded-data.action';
import {LoadExpandedDomainsData} from '../actions/domain-expanded-data.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {auditTime, filter, map, mergeMap} from 'rxjs/operators';
import {HostingService} from "../../websites/website/hosting/hosting.service";
import {pipe} from "rxjs/internal/util/pipe";
import {IDomainExpandedDataEntityState} from "../reducers/domain-expanded-data.reducer";

export enum EPurchasedDomainRegistrarStatus {
    ACTIVE = 'ACTIVE',
    NOT_VERIFIED = 'AWAITING_VERIFICATION_ICANN'
}

export class DomainExpandedDataEntityMapper  {

    public static map(data: any): IDomainExpandedDataEntityState {
        const mappedData: IDomainExpandedDataEntityState = {
            domainPointed: data.domain_pointed || 0,
            hasCertificate: data.has_certificate || 0,
            hasIpv6: data.has_ipv6 || false,
            server: data.server || "",
            tenWebCf: data.tenweb_cf || false,
            tenWebDomain: data.tenweb_domain || false,
            tenWebIp: data.tenweb_ip || false,
            tenWebNs: data.tenweb_ns || false,
            verificationNeeded: data.tenweb_domain_status && data.tenweb_domain_status === EPurchasedDomainRegistrarStatus.NOT_VERIFIED || false,
            pending: data.tenweb_domain_status && data.tenweb_domain_status !== EPurchasedDomainRegistrarStatus.NOT_VERIFIED && data.tenweb_domain_status !== EPurchasedDomainRegistrarStatus.ACTIVE || false,
        };

        return mappedData;
    }
}

@Injectable()
export class DomainExpandedDataEffect {

  constructor(
    private _actions$: Actions,
    private _hostingService: HostingService,
  ) {
  }

  domainExpandedDataList$ = createEffect(() => this._actions$.pipe(
    ofType(ExpandedDomainsDataAction.LOAD_EXPANDED_DATA),
    pipe(
      auditTime(2000),
      mergeMap((action: LoadExpandedDomainsData) => {
        return this._hostingService.checkPointedDomain(action.payload, action.domainNameIds, action.expanded)
          .pipe(
            filter((response: DbResponse) => !!response),
            map((response: DbResponse) => {
              if (response.success && response.data) {
                const entities = {};
                action.domainNameIds.forEach(domainId => {
                  entities[domainId] = DomainExpandedDataEntityMapper.map(response.data.troubleshoot_result[domainId]);
                });

                return new ExpandedDomainsDataAction.ExpandedDomainsDataSuccess({
                  websiteId: action.payload,
                  entities,
                  expanded: action.expanded,
                });
              }
              return new ExpandedDomainsDataAction.ExpandedDomainsDataFail(action.payload);
            })
          );
      })
    )));
}
